export default {
  AUTH: '/auth',
  HOME: '/home',

  LOGIN: '/auth/login',
  CHANGE_PASSWORD: '/auth/change-password',

  ACCOUNT: '/home/account',
  ACCOUNT_INFO: '/home/account-info',
  USER_LIST: '/home/users',

  DASHBOARD: '/dashboard',
  API_KEY_LIST: '/home/applications/:id/api-keys',
  APPLICATION_LIST: '/home/applications',
  DB_LIST: '/home/applications/:id/face-dbs',
  DB_DETAIL: '/home/applications/:id/face-dbs/:type/:db',
  LOCATION_LIST: '/home/applications/:appId/features/:db/locations',
  USER_ID_LIST: '/home/applications/:id/face-dbs/:db/user-ids',
  USER_ID_DETAIL: '/home/applications/:id/face-dbs/:db/user-ids/:userId',
};
